import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnTV: CultureInfo = {
  name: 'en-TV',
  displayName: 'English (Tuvalu)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-TV',
  parent: CultureInfoEn
};
